import {fonts} from '../../theme/foundations/fonts'
import {pxToRem} from '../../utills/pxToRem'

export const addressValidationModalstyles = {
    '.close-button': {
        position: 'absolute',
        minWidth: pxToRem(15),
        height: pxToRem(15),
        top: pxToRem(20),
        right: pxToRem(20),
        opacity: 1,
        img: {
            width: pxToRem(15),
            height: pxToRem(15)
        }
    }
}

export const addressValidationModalContent = {
    maxWidth: [pxToRem(298), pxToRem(298), pxToRem(733), pxToRem(733)],
    borderRadius: 0,
    marginTop: pxToRem(100),
    marginBottom: pxToRem(100),
    position: 'relative',
    '.closeButton': {
        position: 'absolute',
        minWidth: pxToRem(20),
        height: pxToRem(20),
        top: pxToRem(20),
        right: pxToRem(20),
        opacity: 0.5,
        '&:hover': {
            opacity: 1
        },
        img: {
            width: pxToRem(20),
            height: pxToRem(20)
        }
    },
    '.addressValidationModalContent': {
        minWidth: '100%',
        width: '100%',
        border: '2px solir green'
    }
}
